import { getOrderTicketRedemptionCardsForSubscription } from '../../../order/selectors/ticket-redemption-cards/get-order-ticket-redemption-cards-for-subscription';
import { getOrderTicketRedemptionCardsForThirdPartyMemberScheme } from '../../../order/selectors/ticket-redemption-cards/get-order-ticket-redemption-cards-for-third-party-member-scheme';
import { getOrderVouchersForTypeCodes } from '../../../order/selectors/vouchers/get-order-vouchers-for-type-codes';
import { mapMemberRewardTicketPriceToTicketDetails, mapTicketPriceToTicketDetails, mapTicketRedemptionCardPriceToTicketDetails, mapVoucherTicketPriceToTicketDetails } from '../../mappers/ticket-details';
import { isMemberRewardTicketPrice, isMemberSubscriptionTicketPrice, isThirdPartyMemberTicketPrice, isTicketPriceAvailable, isVoucherTicketPrice } from '../../utils/tickets/ticket-price-utils';
import { getTicketPricesForShowtime } from './get-ticket-prices-for-showtime';
/**
 * Gets the available ticket options for a given showtime.
 *
 * Returns undefined if the ticket prices have not been loaded.
 */
export const getTicketOptionsForShowtime = (showtimeId) => {
    const ticketPrices = getTicketPricesForShowtime(showtimeId);
    if (!ticketPrices)
        return undefined;
    const availablePrices = ticketPrices.filter(isTicketPriceAvailable);
    return availablePrices.reduce((acc, price) => {
        return acc.concat(getOptionsForTicketPrice(price));
    }, []);
};
/**
 * We support:
 * - Member reward ticket prices
 * - Voucher ticket prices
 * - Third party member ticket prices
 * - Standard ticket prices
 * - Member subscription ticket prices
 *
 * We do not support any combinations (e.g. voucher + member reward).
 */
const getOptionsForTicketPrice = (price) => {
    if (isMemberRewardTicketPrice(price))
        return getOptionsForMemberRewardTicketPrice(price);
    if (isVoucherTicketPrice(price))
        return getOptionsForVoucherTicketPrice(price);
    if (isThirdPartyMemberTicketPrice(price))
        return getOptionsForThirdPartyMemberTicketPrice(price);
    if (isMemberSubscriptionTicketPrice(price))
        return getOptionsForMemberSubscriptionTicketPrice(price);
    return getOptionsForStandardTicketPrice(price);
};
const getOptionsForStandardTicketPrice = (price) => {
    return [mapTicketPriceToTicketDetails(price)];
};
const getOptionsForMemberRewardTicketPrice = (price) => {
    return [mapMemberRewardTicketPriceToTicketDetails(price)];
};
const getOptionsForVoucherTicketPrice = (price) => {
    const vouchers = getOrderVouchersForTypeCodes(price.voucherTypeCodes);
    return vouchers.map(voucher => mapVoucherTicketPriceToTicketDetails(price, voucher.id));
};
const getOptionsForThirdPartyMemberTicketPrice = (price) => {
    const cards = getOrderTicketRedemptionCardsForThirdPartyMemberScheme(price.thirdPartyMemberSchemeId);
    return cards.map(card => mapTicketRedemptionCardPriceToTicketDetails(price, card.id));
};
const getOptionsForMemberSubscriptionTicketPrice = (price) => {
    const cards = getOrderTicketRedemptionCardsForSubscription(price.subscriptionId);
    return cards.map(card => mapTicketRedemptionCardPriceToTicketDetails(price, card.id));
};
